import React from 'react'

export const provincialFormatPattern = (province) => {
  switch (province) {
    case "ONTARIO":
      return '9999-999-999-aa'
    case "BRITISH COLUMBIA":
      return '9999999999'
    case "NORTHWESTERN TERRITORIES":
      return 'a9999999'
    default:
      return '99999-9999'
  }
}
